import _ from 'lodash'

export function getSubjectsByStage(allSubjects, stage) {
  const subjucts = _.get(allSubjects, stage, [])
  return subjucts
}
